export default __webpack_public_path__ + "static/media/logo.51064cf7.png";